import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

import PopoverPattern from '@mlb/react-patterns/components/Popover/popover.tsx';

import PopoverContent from './PopoverContent';

const Popover = (props) => {

    const {
        button,
        isOpen,
        onClosed,
        reel,
        clipsLoading,
        clipsData,
        lang,
        removeClip,
        reorder,
        openReelCreationModal,
        openClipTrimming,
        isLoggedIn,
        userId,
    } = props;

    return (
        <PopoverPattern
            isOpen={isOpen}
            children={button}
            popoverContent={
                <PopoverContent
                    reel={reel}
                    clipsLoading={clipsLoading}
                    clipsData={clipsData}
                    removeClip={removeClip}
                    reorder={reorder}
                    openReelCreationModal={openReelCreationModal}
                    openClipTrimming={openClipTrimming}
                    isLoggedIn={isLoggedIn}
                    userId={userId}
                    closeReelCreation={onClosed}
                />}
            showMultiple={false}
            popoverOffset={[
                0,
                5,
            ]}
            preventOverflowPadding={20}
            placement={'bottom'}
            closeOnPopperClick={false}
            onClose={onClosed}
        />
    );

};

Popover.propTypes = {
    button: PropTypes.element.isRequired,
    removeClip: PropTypes.func.isRequired,
    reorder: PropTypes.func.isRequired,
    openReelCreationModal: PropTypes.func.isRequired,
    openClipTrimming: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    reel: PropTypes.object.isRequired,
    clipsLoading: PropTypes.bool.isRequired,
    clipsData: PropTypes.array.isRequired,
    onClosed: PropTypes.func,
    isLoggedIn: PropTypes.bool.isRequired,
    userId: PropTypes.string.isRequired,
};

Popover.defaultProps = {
    onClosed: _noop,
};

export default Popover;


